import React, { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function QueryDebugger() {
  useEffect(() => {
    // Add debug logging to Supabase client
    const originalFrom = supabase.from;
    
    supabase.from = function(table: string) {
      const queryBuilder = originalFrom.call(this, table);
      const originalSelect = queryBuilder.select;
      const originalUpsert = (queryBuilder as any).upsert;

      queryBuilder.select = function(columns: any) {
        console.log(`🔍 Supabase Query Debug: Table=${table}, Select=${JSON.stringify(columns)}`);
        try {
          console.trace('🔎 Query call stack');
        } catch {}
        return originalSelect.call(this, columns);
      };

      if (typeof originalUpsert === 'function') {
        (queryBuilder as any).upsert = function(data: any, options?: any) {
          try {
            const rows = Array.isArray(data) ? data.length : (data ? 1 : 0);
            const onConflict = options?.onConflict ?? 'none';
            const ignoreDuplicates = options?.ignoreDuplicates ?? false;
            console.log(
              `🧩 Supabase Upsert Debug: Table=${table}, Rows=${rows}, onConflict=${onConflict}, ignoreDuplicates=${ignoreDuplicates}`
            );
            console.trace('🔎 Upsert call stack');
          } catch {}
          return originalUpsert.call(this, data, options);
        };
      }
      return queryBuilder;
    };
    
    return () => {
      // Restore original method
      supabase.from = originalFrom;
    };
  }, []);
  
  return null; // This is a debug component, renders nothing
}